import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import {
  BoxDanger,
  BoxInfo,
  MnemoCallout,
  MnemoLoading,
  MSection,
  SupportoTecnicoLive,
  Title,
} from "components/misc";
import { dateHelper, lessonLiveService, learningService, networkErrorHelper } from "libs";
import { ROUTES } from "const";
import { Icon, Button } from "design-react-kit";

class CourseLessonLiveScheduleOnlineAll extends Component {

  state = {
    loading: true,
    loadingError: false,
    rCode: "",
    course: {},
    userCourse: {},
    lessons: [],
    liveClass: null,
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.setState({ rCode: rCode });

    this.loadUserCourse(rCode);
  }

  loadUserCourse(rCode) {

    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {

        const { course, userCourse } = data.payload;
        this.setState({ course, userCourse });

        this.loadRemote(course.id, userCourse.registrationCode);
      })
      .catch(error => {

        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
      });
  }

  loadRemote(courseId, rCode) {

    lessonLiveService
      .MyScheduleStageOnlineAll(courseId, rCode)
      .then(({ data }) => {
        this.setState({
          loading: false,
          lessons: data.payload.lessonLiveSchedules,
          liveClass: data.payload.lessonLiveClass,
          sections: data.payload.sections,
        });
      })
      .catch((error) => {
        console.log(error)
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  showLinkIdMeet(lesson) {

    let show = false;

    if (lesson.idMeet) {

      const dayLeft = dateHelper.dayLeft(dateHelper.toUSDate(lesson.date));
      if (dayLeft === 0) {
        const minuteLeft = dateHelper.minuteLeft(lesson.hourStart);

        // il link si attiva da 60 minuti prima a 4 ore dopo l'inizio della lezione
        if (minuteLeft < 60 && minuteLeft > -240) {
          show = true;
        }
      }
    }

    return show;
  }

  showLinkUrlRegister(lesson) {

    let show = false;

    if (lesson.urlRegister) {

      const dayLeft = dateHelper.dayLeft(dateHelper.toUSDate(lesson.date));
      if (dayLeft === 0) {
        const minuteLeft = dateHelper.minuteLeft(lesson.hourStart);

        // il link si attiva da 2 ore prima a 4 ore dopo l'inizio della lezione
        if (minuteLeft < 180 && minuteLeft > -240) {
          show = true;
        }
      }
    }

    return show;
  }

  goDetail = (idLessonLive) => {
    const { rCode } = this.state;
    window.location = `${ROUTES.COURSE_LESSONLIVE_DETAIL}/${rCode}/${idLessonLive}`;
  };

  openLink = (link) => {
    window.open(link, '_blank');
  };

  renderLessons(lessons, userCourse) {

    let creditRecognition = false;
    if (userCourse && userCourse.creditRecognition) {
      creditRecognition = userCourse.creditRecognition;
    }

    return (<MSection className="m-2">
      {lessons.length > 0 ? (
        <>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Attività Formativa</th>
                <th scope="col">Insegnamento</th>
                <th scope="col">Ora Inizio</th>
                <th scope="col">Docente</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {lessons.map((lesson, i) => (
                <tr key={i}>
                  <td>{dateHelper.toITDate(lesson.date)}</td>
                  <td>{lesson.sectionTitle}</td>
                  <td>{lesson.subject}</td>
                  <td>{dateHelper.toShortTime(lesson.hourStart)}</td>
                  <td>{lesson.teacher}</td>
                  <td>
                    {(creditRecognition && lesson.creditRecognition && lesson.creditRecognition.includes(creditRecognition)) ? (<>
                      <p className="btn btn-outline-primary m-1">Attività da non frequentare a seguito di riconoscimento</p>
                    </>) : (<>
                      {this.showLinkUrlRegister(lesson) && (
                        <Button
                          color="primary m-1"
                          outline
                          onClick={(e) => {
                            this.openLink(lesson.urlRegister);
                          }}>
                          Registrati
                        </Button>
                      )}
                      {this.showLinkIdMeet(lesson) && (
                        <>
                          <Button
                            color="primary m-1 btn-block"
                            outline
                            onClick={(e) => {
                              this.openLink(lesson.idMeet);
                            }}>
                            Partecipa
                            {(parseInt(lesson.myRegistrationIDWebex) > 0) && <div><small class="text-muted">codice registrazione: {lesson.myRegistrationIDWebex}</small></div>}
                          </Button>

                        </>
                      )}
                    </>)}
                    <Button
                      id="radio"
                      color="primary bg-dark m-1 btn-block"
                      onClick={(e) => {
                        this.goDetail(lesson.id);
                      }}>
                      Dettaglio
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <BoxInfo className="m-2">
          <p>Pagina in aggiornamento. Calendario a breve disponibile.</p>
        </BoxInfo>
      )}

    </MSection>)
  }

  render() {
    const {
      loading,
      loadingError,
      lessons,
      rCode,
      userCourse,
    } = this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;
    if (loadingError)
      return (
        <BoxDanger className="m-5">
          Si è verificato un errore durante l'elaborazione della richiesta. <SupportoTecnicoLive courseCode={userCourse.courseCode} />
        </BoxDanger>
      );

    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right">
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Attività telematiche in modalità sincrona</Title>
        {this.renderLessons(lessons, userCourse)}
        <div className="m-2">
          <MnemoCallout>
            <p>Non è consentito accedere all'attività trascorse quattro ore dal suo inizio.</p>
          </MnemoCallout>
          <MnemoCallout>
            <p>Calendario Attività didattica in modalità telematica sincrona in aggiornamento.</p>
          </MnemoCallout>
        </div>
        <SupportoTecnicoLive courseCode={userCourse.courseCode} />.
      </>
    );
  }
}

export default withRouter(CourseLessonLiveScheduleOnlineAll);
